import { render, staticRenderFns } from "./HomePc.vue?vue&type=template&id=9543e8aa&scoped=true&"
import script from "./HomePc.vue?vue&type=script&lang=js&"
export * from "./HomePc.vue?vue&type=script&lang=js&"
import style0 from "./HomePc.vue?vue&type=style&index=0&id=9543e8aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9543e8aa",
  null
  
)

export default component.exports